import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import { Row, Col, Button, Card, Badge } from 'react-bootstrap';
import moment from 'moment';
import "./DashboardAnnouncementsList.css";
import PageLoading from "../../../container/PageLoading/PageLoading";
import { fetchBroadcastFeed } from '../../../store/actions/broadcasts/broadcastActions';

/**
 * Dashboard -> "All Announcements" tab, read from the announcements engine feed
 * (GET /broadcasts/feed). Cards keep their previous look; the legacy
 * get_dashboard_all/3 stored procedure is no longer called.
 */

// First page of 6, then "Show More" pages of 3 (matches the old SP paging).
const FIRST_PAGE = 6;
const MORE_PAGE = 3;

const DEFAULT_THUMBNAIL = "https://images.unsplash.com/photo-1462396240927-52058a6a84ec?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1073&q=80";

// The feed sends UTC instants; the card shows the calendar date in the viewer's local time.
const localDate = (utc) => (utc ? moment.utc(utc).local().format("YYYY-MM-DD") : "");

class DashboardAnnouncementsList extends Component {

  state = {
    dep_id: "all",
  };

  componentDidMount() {
    this.props.fetchBroadcastFeed({ page: 1, per_page: FIRST_PAGE });
  }

  // Only sent when a department is chosen; "All" means no filter.
  filterParams = (dep_id) => (dep_id && dep_id !== "all" ? { dep_id: dep_id } : {});

  handleSelectDepartment = (event) => {
    const dep_id = event.target.value;
    this.setState({ dep_id: dep_id });
    this.props.fetchBroadcastFeed({ page: 1, per_page: FIRST_PAGE, ...this.filterParams(dep_id) });
  }

  handleShowMore = () => {
    const nextPage = (Number(this.props.feed.page) || 1) + 1;
    this.props.fetchBroadcastFeed({ page: nextPage, per_page: MORE_PAGE, ...this.filterParams(this.state.dep_id) });
  }

  render() {
    const { feed } = this.props;

    return (
      <>
        <Row>
          <Col>
            <div className="form-group dashboard-dep-select">
              <label htmlFor="dashboard-announcement-department">Departments Announcement:</label>
              <select
                id="dashboard-announcement-department"
                name="department_id"
                className="form-control"
                value={this.state.dep_id}
                onChange={this.handleSelectDepartment}
                style={{ display: 'block' }}
              >
                <option value="all">All</option>
                {feed.departments.map((department) => (
                  <option key={department.id} value={department.id}>{department.name}</option>
                ))}
              </select>
            </div>
          </Col>
        </Row>
        <AnnouncementListTable feed={feed} onShowMore={this.handleShowMore} />
      </>
    );
  }
}

const AnnouncementListTable = ({ feed, onShowMore }) => {
  if (!feed.isLoaded) {
    if (feed.loadError) {
      return (
        <Row>
          <Col md={12} align="center">
            <h5>Couldn't load announcements right now.</h5>
          </Col>
        </Row>
      );
    }
    return <PageLoading />;
  }

  if (feed.list.length === 0) {
    return (
      <Row>
        <Col md={12} align="center">
          <h5>No Announcements.</h5>
        </Col>
      </Row>
    );
  }

  return (
    <Row>
      {feed.list.map((announcement) => (
        <Col md={4} key={announcement.id} className="announcement-list-content dashbaord-content card-content">
          {announcement.on_link == 1 ? (
            <a href={announcement.link} target="_blank" rel="noopener noreferrer">
              <AnnouncementItem {...announcement} />
            </a>
          ) : (
            <Link to={{ pathname: global.links.announcement_page + announcement.id }} title="View Announcement">
              <AnnouncementItem {...announcement} />
            </Link>
          )}
        </Col>
      ))}
      {feed.hasMore ? (
        <Col md={12} align="center">
          <Button onClick={onShowMore} className="show-more-dashboard">Show More</Button>
        </Col>
      ) : (
        <Col md={12} align="center">
          <h5>No More Announcements to Show</h5>
        </Col>
      )}
    </Row>
  );
}

const AnnouncementItem = (announcement) => {
  const posted = localDate(announcement.starts_at);
  const isNew = announcement.starts_at && moment.utc(announcement.starts_at).isAfter(moment().subtract(3, "days"));

  return (
    <div className="announcement-list-item">
      <Card className="announcement-list-card">
        {/* The feed card's `thumbnail` is already a public URL (BroadcastPresenter::card -> diskUrl), or null. */}
        <Card.Img variant="top" src={announcement.thumbnail || DEFAULT_THUMBNAIL} className="announcement-list-img" />
        <Card.ImgOverlay className={"mask-" + announcement.category}>
          <Card.Title className="text-white card-text-white">
            {announcement.title} {announcement.on_link == 1 ? <i className="nav-icon fa fa-link" /> : null}
          </Card.Title>
          <Card.Text className="card-text-white card-text-overflow">
            {announcement.headline}
          </Card.Text>
        </Card.ImgOverlay>
      </Card>
      <div className="card-text-black">
        <div className="card-bottom-content">
          <Badge className="tag-badge">{announcement.department_name}</Badge>
          {isNew ? <Badge className="new-badge">NEW ANNOUNCEMENT</Badge> : null}
          <br />
          <> Posted on: {posted}</>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user : state.user,
    feed : state.broadcasts.feed,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    fetchBroadcastFeed : (params) => dispatch( fetchBroadcastFeed(params) ),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(DashboardAnnouncementsList);
